(() => {
  'use strict';

  const configSelector = 'script[data-doyo-mobile-nav-config]';
  const nativeContentSelector = '.doyo-header-drawer__native-content';
  const bundleLoads = new Map();

  function findConfig(scope = document) {
    if (scope.matches?.(configSelector)) return scope;
    return scope.querySelector?.(configSelector);
  }

  function parseConfig(configElement) {
    const configText = configElement.textContent || '{}';

    try {
      return JSON.parse(configText);
    } catch (error) {
      const position = Number(/position (\d+)/.exec(error.message)?.[1]);
      const context = Number.isFinite(position)
        ? configText.slice(Math.max(0, position - 160), position + 160)
        : configText.slice(0, 320);
      console.error('[Doyo Mobile Nav] Invalid configuration JSON.', {
        error,
        length: configText.length,
        position: Number.isFinite(position) ? position : null,
        context,
      });
      return null;
    }
  }

  function loadBundle(src) {
    if (window.doyobest?.apps?.DoyoMobileNav) return Promise.resolve();
    if (bundleLoads.has(src)) return bundleLoads.get(src);

    const load = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = src;
      script.defer = true;
      script.addEventListener('load', resolve, { once: true });
      script.addEventListener('error', () => reject(new Error(`Unable to load ${src}`)), { once: true });
      document.head.append(script);
    });

    bundleLoads.set(src, load);
    return load;
  }

  function nativeContent(host) {
    return host.closest('.menu-drawer__navigation-container')?.querySelector(nativeContentSelector);
  }

  function appendUtilities(configElement, host) {
    const template = configElement.parentElement?.querySelector('[data-doyo-mobile-nav-utilities]');
    if (template instanceof HTMLTemplateElement) {
      host.append(template.content.cloneNode(true));
    }
  }

  async function init(configElement) {
    const config = parseConfig(configElement);
    const host = document.getElementById(configElement.dataset.hostId);
    if (!config || !host) return;

    try {
      await loadBundle(configElement.dataset.appSrc);
      const app = window.doyobest?.apps?.DoyoMobileNav;
      if (!app) throw new Error('DoyoMobileNav bundle did not expose its application.');

      app.destroy();
      host.replaceChildren();
      await app.init(`#${host.id}`, {
        config,
        debug: window.location.hostname === '127.0.0.1',
        globalVars: { GLOBAL_ICN_CLOSE: configElement.dataset.closeIconSrc || '' },
      });
      appendUtilities(configElement, host);
      host.hidden = false;
      nativeContent(host)?.setAttribute('hidden', '');
    } catch (error) {
      console.error('[Doyo Mobile Nav] Initialization failed.', error);
      host.replaceChildren();
      host.hidden = true;
      nativeContent(host)?.removeAttribute('hidden');
    }
  }

  function destroy(configElement) {
    const host = document.getElementById(configElement.dataset.hostId);
    window.doyobest?.apps?.DoyoMobileNav?.destroy();
    if (!host) return;

    host.replaceChildren();
    host.hidden = true;
    nativeContent(host)?.removeAttribute('hidden');
  }

  function initWithin(scope) {
    const configElement = findConfig(scope);
    if (configElement) init(configElement);
  }

  function destroyWithin(scope) {
    const configElement = findConfig(scope);
    if (configElement) destroy(configElement);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initWithin(document), { once: true });
  } else {
    initWithin(document);
  }
  document.addEventListener('shopify:section:load', (event) => initWithin(event.target));
  document.addEventListener('shopify:section:unload', (event) => destroyWithin(event.target));
})();
